import React from 'react';
import { Card } from '../ui/Card';
import type { LeadSource, PriorityRule } from '../../types';
interface ConfigOverviewProps {
  sources: LeadSource[];
  priority: PriorityRule[];
  lastPublished: string;
}
export function ConfigOverview({
  sources,
  priority,
  lastPublished
}: ConfigOverviewProps) {
  const activeSources = sources.filter(s => s.enabled);
  const cadenceRules = activeSources.reduce((sum, s) => sum + s.rules.filter(r => r.enabled).length, 0);
  const activePriority = priority.filter(r => r.enabled);
  const governed = activePriority.reduce((sum, r) => sum + r.leadCount, 0);
  const items = [{
    label: 'Active Lead Sources',
    value: `${activeSources.length} of ${sources.length}`
  }, {
    label: 'Active Cadence Rules',
    value: String(cadenceRules)
  }, {
    label: 'Priority Rules',
    value: `${activePriority.length} of ${priority.length}`
  }, {
    label: 'Leads Governed',
    value: governed.toLocaleString()
  }, {
    label: 'Last Published',
    value: lastPublished
  }];
  return <Card className="grid grid-cols-2 gap-y-5 px-6 py-5 sm:grid-cols-3 lg:grid-cols-5" data-id="element-49" data-mp="12t8cz1xqwy1b">
      {items.map(item => <div key={item.label} data-id="element-50" data-mp="17rrzb3g94bu7">
          <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-400" data-id="element-51" data-mp="17v5zc51g08yh">
            {item.label}
          </p>
          <p className="tabular mt-1.5 text-base font-semibold text-ink-900" data-id="element-52" data-mp="1hs2a6hetd767">{item.value}</p>
        </div>)}
    </Card>;
}